import type { FeatureMiddleware } from '@cast/api-client';
import { demoScheduledRebalancingListSchedules } from '@cast/fixtures';

import {
  getIsClusterDemoMode,
  getIsSecurityDemoMode,
} from '@cast/infrastructure-demo';

export const scheduledRebalancing: FeatureMiddleware<'scheduledRebalancing'> = {
  listSchedules: async ({ next, resolve }) => {
    if (
      getIsClusterDemoMode() ||
      (getIsSecurityDemoMode() &&
        window.location.pathname.includes('/security'))
    ) {
      const fixture = await demoScheduledRebalancingListSchedules();
      return resolve(fixture);
    }
    return next();
  },
};
